<template>
  <v-container class="py-0">
    <v-row align="center" justify="start">
      <v-col class="py-0 pr-0" cols="11">
        <v-autocomplete
          :items="items"
          v-model="selectedSupplier"
          :label="label"
          item-text="name"
          :item-value="itemValue"
          :clearable="clearable"
          @click:clear="clear"
          :outlined="outlined"
          :hide-details="hideDetails"
          :dense="dense"
          @input="onInput"
          :disabled="disabled"
        ></v-autocomplete>
      </v-col>
      <v-col class="py-0 pl-0" cols="1">
        <v-menu top close-on-click>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
              icon
              class="ml-1"
              ><v-icon>{{
                supplierTypeIcon(selectedSupplierType)
              }}</v-icon></v-btn
            >
          </template>

          <v-list>
            <v-list-item
              v-for="(item, index) in supplierTypes"
              :key="index"
              @click="selectedSupplierType = item"
            >
              <v-list-item-title>{{ item }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
    </v-row>
  </v-container>
</template>
  
  <script>
import gql from "graphql-tag";
import { removeGQLTypename } from "../../../helpers";
import { SupplierTypeIconMixin } from "../../../mixins/SupplierTypeIconMixin";
import { SUPPLIER_TYPES } from "../../../constants/supplierTypes";
const SUPPLIERS_LIST = gql`
  query allSuppliersNames($filter: SupplierFilterType) {
    suppliers(filter: $filter) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;
export default {
  name: "supplier-list-select-by-type",
  mixins: [SupplierTypeIconMixin],
  props: {
    supplierType: {
      type: String,
      default: () => "ACCOMMODATION",
    },
    hideDetails: {
      type: Boolean,
      default: () => false,
    },
    clearable: {
      type: Boolean,
      default: () => false,
    },
    outlined: {
      type: Boolean,
      default: () => false,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    dense: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: String,
      default: () => "",
    },
    itemValue: {
      type: String,
      default: () => "id",
    },
    label: {
      type: String,
      default: () => "Supplier",
    },
  },

  data() {
    return {
      debug: false,
      selectedSupplier: this.value,
      selectedSupplierType: this.supplierType,
      // search: null,
      // searchTimeout: null,
      // searchDebounceTime: 700,
      // nameFilter: null,
      supplierTypes: SUPPLIER_TYPES,
    };
  },

  computed: {
    items() {
      return this.suppliers && this.suppliers.edges
        ? this.suppliers.edges.map(removeGQLTypename)
        : [];
    },
  },
  watch: {
    value(newVal) {
      this.selectedSupplier = newVal;
    },
    supplierType(newVal) {
      this.selectedSupplierType = newVal;
    },
    supplierType(newVal) {
      this.selectedSupplierType = newVal;
    },
  },

  methods: {
    clear() {
      this.$emit("clear");
      this.$emit("onClear");
    },
    onInput(data) {
      this.$emit("input", data);
    },
  },

  apollo: {
    suppliers: {
      query: SUPPLIERS_LIST,
      variables() {
        return {
          filter: { service_type: this.selectedSupplierType },
        };
      },
    },
  },
};
</script>
  
  <style></style>
  


// WEBPACK FOOTER //
// src/components/gt/shared/SupplierListSelectByType.vue